import { map, multiply } from 'lodash/fp'

import { QuizQuestionType } from './types/QuizQuestionType'

export const API_ERROR_LEARNPATHS_VALID_URL =
  'api.error.field-is-not-a-valid-url'
export const API_ERROR_LEARNPATHS_ELEMENTS_NOT_READY =
  'learnpath.error.learnpath-elements-not-ready'
export const API_ERROR_LEARNPATHS_COMPLETE_UNTIL_FROM_PAST =
  'api.error.date-is-from-the-past'

export const IMAGE_UPLOAD_MAX_FILE_SIZE = 10485760 // 10MB

export const FILTER_USE_ALL = 'use-all'

export const ADD_MEMBER_ERROR_MIN_CHARACTERS =
  'learnpaths.add-members.error.min-characters-not-reached'

export const MINIMAL_NUMBER_OF_CHARACTERS = 3

export const CREATOR_STEP_GENERAL_INFORMATION = 'general-information'
export const CREATOR_STEP_GENERAL_INFORMATION_COURSE =
  'general-information-course'
export const CREATOR_STEP_ELEMENTS = 'elements'
export const CREATOR_STEP_COMPLETION_TIME = 'completion-time'
export const CREATOR_STEP_LEARNERS = 'learners'

export const CREATOR_STEPS_LEARNPATH = [
  CREATOR_STEP_GENERAL_INFORMATION,
  CREATOR_STEP_ELEMENTS,
  CREATOR_STEP_COMPLETION_TIME,
  CREATOR_STEP_LEARNERS,
]
export const CREATOR_STEPS_ALL = [
  CREATOR_STEP_GENERAL_INFORMATION_COURSE,
  ...CREATOR_STEPS_LEARNPATH,
]

export const LEARNPATH_THUMBNAIL_ACCEPTED_FILE_EXTENSIONS = [
  '.png',
  '.jpg',
  '.jpeg',
]
// 2 GiB minus 1 byte — kept within the 32-bit INT max so the backend
// filesize columns don't need a migration to bigint.
export const LEARNPATH_ASSET_MAX_FILE_SIZE = 2 * 1024 * 1024 * 1024 - 1
export const LEARNPATH_THUMBNAIL_MAX_FILE_SIZE = 20 * 1024 * 1024 // 20MB

export const LEARNPATH_CREATOR_POINTS_MAX = 100
export const LEARNPATH_CREATOR_RECURRING_INTERVAL_MAX = 1000

export const LEARNPATH_FILE_UPLOAD_URL = '/learnpaths/uploads/file'
export const LEARNPATH_VIDEO_UPLOAD_URL = '/learnpaths/uploads/video'

/* Thumbnail sizes */

export const LEARNPATH_THUMBNAIL_SIZE_RECOMMENDED_WIDTH = 1430
export const LEARNPATH_THUMBNAIL_SIZE_RECOMMENDED_HEIGHT = 760

export const LEARNPATH_THUMBNAIL_SIZE_GENERIC_RECOMMENDED_WIDTH = 1160
export const LEARNPATH_THUMBNAIL_SIZE_GENERIC_RECOMMENDED_HEIGHT = 720

export const ELEMENT_TYPE_PLATFORM_TOPIC = 'platform_topic'
export const ELEMENT_TYPE_SCORM = 'scorm'
export const ELEMENT_TYPE_VIDEO = 'video'
export const ELEMENT_TYPE_EMBEDDED_VIDEO = 'embedded_video'

export const ELEMENT_LIST_ERROR_EMPTY = 'learnpaths-add-elements-error.empty'
export const ELEMENT_LIST_ERROR_STATUS = 'learnpaths-add-elements-error.status'

export const PLATFORM_TOPIC_ORDER_TOP_RATED = 'top_rated'
export const PLATFORM_TOPIC_ORDER_RELEVANCE = 'relevance'
export const PLATFORM_TOPIC_ORDER_MOST_VIEWED = 'most_viewed'
export const PLATFORM_TOPIC_ORDER_MOST_RECENT = 'most_recent'
export const PLATFORM_TOPIC_ORDER = [
  PLATFORM_TOPIC_ORDER_RELEVANCE,
  PLATFORM_TOPIC_ORDER_TOP_RATED,
  PLATFORM_TOPIC_ORDER_MOST_VIEWED,
  PLATFORM_TOPIC_ORDER_MOST_RECENT,
] as const

export const LEARNPATH_QUIZ_QUESTION_TYPES = [
  'single_choice',
  'multiple_choice',
] satisfies QuizQuestionType[]

export const LEARNPATH_ASSIGNMENT_METHOD_LINK = 'link'

export const DEFAULT_PREVIEW_LEARNPATH = 'system/media-upload/default-thumbnail'

const SECONDS_IN_MINUTE = 60
export const LEARNPATH_ELEMENT_DURATION_STEPS = map(
  multiply(SECONDS_IN_MINUTE),
  [1, 5, 10, 15, 30, 45, 60, 90, 120, 150, 180],
)
